module.exports = __webpack_public_path__ + "img/quoteRight.124c46e1.svg";